export default __webpack_public_path__ + "static/media/Premium_icon.aad78bcf.png";